
import { defineComponent } from 'vue'
import { Loader } from '@/components'
import { createNamespacedHelpers } from 'vuex'
import { AlertType } from '@/enums'
import { humanizedClockingInTiming } from '@/utilities'
const { mapActions } = createNamespacedHelpers('workingSites')

export default defineComponent({
  name: 'WorkingSiteTimingCard',

  components: {
    Loader
  },

  data () {
    return {
      deleteRelatedDocument: false,
      loading: false
    }
  },

  props: {
    modelValue: {
      type: Number,
      required: true
    }
  },

  computed: {
    id: function (): string {
      return (this.$route as any).params.workingSiteId
    },
    durationHumanized: function (): string {
      return humanizedClockingInTiming(this.modelValue)
    }
  },

  methods: {
    ...mapActions(['deleteWorkingSiteTiming']),
    onTimingDelete: async function () {
      console.log('onTimingDelete')
      this.loading = true

      try {
        const result = await this.deleteWorkingSiteTiming({ workingSiteId: this.id, timing: this.modelValue })

        this.loading = false
        if (!result) {
          await this.$store.dispatch('alerts/create', { message: 'eliminazione ora viaggio fallita', type: AlertType.error })
          return
        }

        await this.$store.dispatch('alerts/create', { message: 'eliminazione ora viaggio riuscita', type: AlertType.success })
      } catch (error) {
        console.error('error creating the document', error)
        this.loading = false
        await this.$store.dispatch('alerts/create', { message: 'eliminazione ora viaggio fallita', type: AlertType.error })
      }
    }
  }
})
